import React from "react";
import RankBonusGrid from "./RankBonusGrid";
import RuleItemView from "./RuleItemView";
import AddClassForm from "./forms/AddClassForm";
import { RuleItem } from "../interfaces/RuleItem";
import NewRuleItemForm from "./forms/NewRuleItemForm";
import StatsForSelected from "./StatsForSelected";
import { RuleModuleType } from "../constants/constants";
import { RuleModuleContext } from "../contexts/RuleModuleContext";
import Alerts from "./Alerts";
import { AlertType } from "../types/AlertTypes";
import SpendableImprovements from "./SpendableImprovements";
import { CharacterSheetContext } from "../contexts/CharacterSheetContext";
import { BonusBreakdownContext } from "../contexts/BonusBreakdownContext";
import { RuleItemContext } from "../contexts/RuleItemContext";
import { SpendingOnType } from "../interfaces/SpendablesForModules";

export default () => {
  const {
    getKeys,
    moduleType,
    moduleName,
    getStatDefinitions,
    dataTest,
    key,
    getRuleItem,
  } = React.useContext(RuleModuleContext);
  const { adminMode, characterEditMode } = React.useContext(
    CharacterSheetContext
  );
  const { currentBonuses } = React.useContext(BonusBreakdownContext);

  let ruleItems: JSX.Element[] = getKeys()
    .filter((itemKey) => adminMode || itemKey in currentBonuses)
    .map((itemKey: string) => (
      <RuleItemContext.Provider
        value={getRuleItem(itemKey)}
        key={`rule-item-view-${itemKey}`}
      >
        <RuleItemView />
      </RuleItemContext.Provider>
    ));

  let newRuleItemForm: JSX.Element | undefined;

  if (adminMode) {
    newRuleItemForm = <NewRuleItemForm key={`add-${moduleType}`} />;
  } else {
    switch (moduleType) {
      case RuleModuleType.SelectAndRank:
      case RuleModuleType.SelectOnly:
        if (!adminMode && characterEditMode) {
          newRuleItemForm = <AddClassForm />;
        }
        break;
    }
  }

  let statsForSelected: JSX.Element | undefined = undefined;

  const stats: RuleItem[] = getStatDefinitions().ruleItems;
  if (stats.length > 0) {
    statsForSelected = <StatsForSelected key={`stat-section-${key}`} />;
  }

  return (
    <div className={`grid-rule-module-section section-${dataTest()}`}>
      <RankBonusGrid
        ruleModuleType={moduleType}
        name={moduleName}
        newForm={newRuleItemForm}
        testKey={`${dataTest()}-${moduleType}`}
        adminMode={adminMode}
      >
        <Alerts alertType={AlertType.MODULE} itemKey={key} />
        <SpendableImprovements
          moduleKey={key}
          spendingOn={SpendingOnType.RULES}
        />
        {ruleItems}
      </RankBonusGrid>
      {statsForSelected}
    </div>
  );
};
